import { useQuery, useMutation } from '@maui/react-query'
import { useMatiApiClient } from './client'

export const useAiSummaryQuery = (ids, search, options = {}) => {
  const api = useMatiApiClient('aai')
  const checkIds = Array.isArray(ids) ? ids : []
  const enabled = checkIds.length > 0

  return useQuery({
    queryFn: () => api.summary({ ids, search }),
    queryKey: ['aiSummary', ids],
    refetchOnWindowFocus: false,
    ...options,
    enabled: (options.enabled ?? true) && enabled,
  })
}

export const useAiSummaryFeedbackMutation = (ids, options = {}) => {
  const api = useMatiApiClient('aai')

  return useMutation({
    optimisticUpdateKey: ['aiSummaryFeedback', ids],
    mutationFn: (feedback) => {
      const response = api.summaryFeedback({ ids, feedback })
      return response
    },
    ...options
  })
}
